"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericFallbackComponent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const GenericError_1 = require("../GenericError");
function GenericFallbackComponent(props) {
    return jsx_runtime_1.jsx(GenericError_1.GenericError, { onTryAgain: props.resetErrorBoundary, error: props.error }, void 0);
}
exports.GenericFallbackComponent = GenericFallbackComponent;
//# sourceMappingURL=index.js.map